import React, { useState } from 'react';
import InputField from '../../components/InputField/InputField';
import Button from '../../components/Button/Button';
import { login } from '../../api';
import { useNavigate } from 'react-router-dom';
import './_styles.login.scss';

const initialState = {
  email: '',
  password: '',
  partyId: 0
};

const LoginScreen = () => {
  const [formData, setFormData] = useState(initialState);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    login(formData)
      .then((res) => {
        localStorage.setItem('profile', JSON.stringify({ ...res.data }));
        navigate('/');
      })
      .catch((err) => {
        alert('Incorrect Credentials');
      });
  };

  return (
    <div className='login'>
      <div>
        <h3 style={{ color: '#001F48' }}>Login</h3>
        <form onSubmit={handleSubmit}>
          <InputField
            placeholder='Username'
            name='email'
            onChange={handleChange}
          />
          <InputField
            placeholder='Password'
            name='password'
            onChange={handleChange}
            type='password'
          />
          <Button title='Login' type='submit' />
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
